import React from 'react';

const Insights = () => {
  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h1>Insights</h1>
      <p>Get the latest insights from the hospitality industry.</p>
    </div>
  );
};

export default Insights;
